// Definição para o modal de busca de Organizações (multi-organização).
// Utilizada no cadastro de Usuários para seleção das organizações vinculadas.
// O endpoint /Organizacoes já é escopado pelo banco Tenant ativo (empresaAtiva).

export const configBuscaOrganizacao = {
  label: 'Organização',
  placeholder: 'ID ou Nome...',
  titulo: 'Buscar Organização',
  endpointApi: 'Organizacoes',
  idField: 'idOrganizacao',
  displayField: 'idOrganizacao',
  descField: 'nomeFantasia',

  camposFiltro: [
    { label: 'Nome Fantasia', model: 'nomeFantasia', tipo: 'text' }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idOrganizacao', width: '15%' },
    { header: 'Nome Fantasia', dataField: 'nomeFantasia', width: '45%' },
    { header: 'Razão Social', dataField: 'razaoSocial', width: '40%' }
  ]
}
